<div class="manage-location-dialog ups-dialog">
    <div class="dialog-header">
        <h2 *ngIf="editMode" mat-dialog-title>{{'EditShipFromLocation'|translate}}</h2>
        <h2 *ngIf="!editMode" mat-dialog-title>{{'AddNewShipFromLocation'|translate}}</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button class="icon-button close-button" mat-dialog-close mat-raised-button type="button">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <ng-container [ngTemplateOutlet]="form"></ng-container>
    </mat-dialog-content>
</div>
<ng-template #form>
    <div *ngIf="editMode">
        <div class="form-group inline-block ">
            <strong>
                <p *ngIf="shippingLocation.UPSPickUpType===2">
                    {{'UPSPickUpType2Info1'|translate}} </p>
                <p *ngIf="shippingLocation.UPSPickUpType===2"> {{'UPSPickUpType2Info2'|translate}}
                </p>
                <p *ngIf="isGuest">
                    {{'GuestInfo'|translate}}
                </p>
            </strong>
        </div>
    </div>

    <form [formGroup]="locationForm" class="ups-form">
        <div class="form-body">
            <mat-form-field>
                <mat-label>{{'LocationName'|translate}}</mat-label>
                <input autocomplete="off"
                       formControlName="NickName"
                       matInput
                       required
                       type="text">
                <mat-error *ngIf="locationForm.controls.NickName.errors">
                    <span *ngIf="locationForm.controls.NickName.errors?.required">
                        {{'LocationNameRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{'ShipperFirstName'|translate}}</mat-label>
                <input autocomplete="off"
                       formControlName="FirstName"
                       matInput
                       required
                       type="text">
                <mat-error *ngIf="locationForm.controls.FirstName.errors?.required">
                    <span *ngIf="locationForm.controls.FirstName.errors?.required">
                        {{'FirstNameRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{'ShipperLastName'|translate}}</mat-label>
                <input autocomplete="off"
                       formControlName="LastName"
                       matInput
                       required
                       type="text">
                <mat-error *ngIf="locationForm.controls.LastName.errors?.required">
                    <span *ngIf="locationForm.controls.LastName.errors?.required">
                        {{'LastNameRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{'CompanyName'|translate}}</mat-label>
                <input autocomplete="off"
                       formControlName="CompanyName"
                       matInput
                       type="text">
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{'EmailAddress'|translate}}</mat-label>
                <input autocomplete="off"
                       formControlName="Email"
                       matInput
                       type="email">
                <mat-error *ngIf="locationForm.controls.Email.errors">
                    <span *ngIf="locationForm.controls.Email.errors">
                        {{'EmailAddressInvalidFormat'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{'Phone'|translate}}</mat-label>
                <input autocomplete="off"
                       formControlName="TelephoneNo"
                       matInput
                       maxlength="15"
                       pattern="\d*"
                       required
                       type="text">
                <mat-error *ngIf="locationForm.controls.TelephoneNo?.errors">
                    <span *ngIf="locationForm.controls.TelephoneNo?.errors?.required">
                      {{'TelephoneNumberRequired'|translate}}
                    </span>
                    <span *ngIf="locationForm.controls.TelephoneNo?.errors?.pattern">
                        {{'OnlyInteger'|translate: { field: 'Telephone No' } }}
                    </span>
                    <span *ngIf="!locationForm.controls.TelephoneNo?.errors?.pattern && locationForm.controls.TelephoneNo?.errors?.minlength">
                        {{ 'validation.PhoneNumberAtleast10Digit' | translate }}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{'Fax'|translate}}</mat-label>
                <input autocomplete="off"
                       formControlName="FaxNo"
                       matInput
                       type="text">
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{'StreetAddress'|translate}}</mat-label>
                <input autocomplete="off"
                       formControlName="StreetAddress"
                       matInput
                       required
                       type="text">
                <mat-error *ngIf="locationForm.controls.StreetAddress.errors?.required">
                    <span *ngIf="locationForm.controls.StreetAddress.errors?.required">
                        {{'StreetAddressRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{'SuiteOrApartment'|translate}}</mat-label>
                <input autocomplete="off"
                       formControlName="ApartmentSuite"
                       matInput
                       type="text">
            </mat-form-field>
            <mat-form-field *ngIf="isFRITUser" matTooltip="If this location needs a door code, enter it here" matTooltipPosition="above">
                <mat-label>{{'AdditionalAddressInformation'|translate}}</mat-label>              
                <input autocomplete="off" formControlName="AdditionalAddressInformation" matInput type="text">
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'Country'|translate}}</mat-label>
                <mat-select (selectionChange)="onCountryChange($event.value)" formControlName="Country" required>
                    <mat-option *ngFor="let country of countriesList" value="{{country.CountryCode}}">
                        {{country.CountryName}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="locationForm.controls.Country.errors?.required">
                    <span *ngIf="locationForm.controls.Country.errors?.required">
                                {{'SelectACountry'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{'PostalCode'|translate}}</mat-label>
                <input [required]="isZipMandatory === true ? true : null"
                       autocomplete="off"
                       formControlName="Zip"
                       matInput
                       type="text">
                <mat-error *ngIf="isZipMandatory && locationForm.controls.Zip.errors?.required">
                    <span *ngIf="isZipMandatory && locationForm.controls.Zip.errors?.required">
                        {{'ZipCodeRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{'City'|translate}}</mat-label>
                <input autocomplete="off"
                       formControlName="City"
                       matInput
                       maxlength="29"
                       required
                       type="text">
                <mat-error *ngIf="locationForm.controls.City.errors?.required">
                    <span *ngIf="locationForm.controls.City.errors?.required">
                        {{'CityRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{'StateOrProvince'|translate}}</mat-label>
                <input [required]="isStateProvince === true ? true : null"
                       autocomplete="off"
                       formControlName="State"
                       matInput
                       type="text">
                <mat-error *ngIf="locationForm.controls.State.errors?.required">
                    <span *ngIf="locationForm.controls.State.errors?.required">
                        {{'StateProvinceRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>

            <!--<div class="checkboxes">
                <mat-checkbox formControlName="IsUserDefault">{{'SetAsDefault'|translate}}</mat-checkbox>
            </div>-->
        </div>
        <div class="form-footer">
            <div class="form-actions">
                <button (click)="updateLocation()"
                        *ngIf="editMode && shippingLocation.UPSPickUpType !== UPSPickupType.DailyPickUp && !isGuest"
                        [disabled]="!locationForm.valid"
                        class="form-action"
                        mat-raised-button
                        type="submit">
                    {{'Update'|translate}}
                </button>
                <button (click)="saveLocation()"
                        *ngIf="!editMode"
                        [disabled]="!locationForm.valid"
                        class="form-action"
                        mat-raised-button
                        type="submit">
                    {{'Save'|translate}}
                </button>
            </div>
        </div>
    </form>
</ng-template>
